export default __webpack_public_path__ + "static/media/662.c4503e62.png";